/*
    This is the controller for Modify Plan Directive
 */
var ModifyPlanController = /** @class */ (function () {
    /*@ngInject*/
    function ModifyPlanController($rootScope, $filter, planService, dateTimeUtilityService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.planService = planService;
        this.dateTimeUtilityService = dateTimeUtilityService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    ModifyPlanController.prototype.$onInit = function () {
        this.isTrialPlan = false;
        this.isVendorPlan = false;
        this.browserTimeZone = this.dateTimeUtilityService.guessBrowserTimeZoneName();
        this.selectedPlanCopy = angular.copy(this.selectedPlan);
        this.initializeStartAndEndDates();
        this.selectedPlanType = this.selectedPlan.planHeaderDto.planType;
        if (this.selectedPlanName.toLowerCase() == 'trial') {
            this.isTrialPlan = true;
        }
        if (this.selectedPlanName.toLowerCase() == 'vendor only') {
            this.isVendorPlan = true;
        }
        this.selectedPlan.planDetailDto.taAdded = 0;
        this.selectedPlan.planDetailDto.jbiAdded = 0;
    };
    // function timeZoneChanged(){
    //     let currentDateTimeStringInSelectedTimeZone = moment().tz(this.selectedPlan.planHeaderDto.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
    //     let currentDate = new Date(currentDateTimeStringInSelectedTimeZone);
    //     let momentOfCurrentDate = moment(currentDate);
    //     let currentDateTimeRoundedToTheHour = momentOfCurrentDate.minute() || momentOfCurrentDate.second() || momentOfCurrentDate.millisecond() ? momentOfCurrentDate.add(1, 'hour').startOf('hour').toDate() : momentOfCurrentDate.startOf('hour').toDate();
    //     $("#effectiveStartDate").datepicker("setDate", currentDate);
    //     $("#effectiveStartDate").datepicker("setStartDate", currentDate);
    //     $("#effectiveStartDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(currentDate));
    //     $("#effectiveEndDate").datepicker("setDate", currentDateTimeRoundedToTheHour);
    //     $("#effectiveEndDate").datepicker("setStartDate", currentDate);
    //     $("#effectiveEndDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(currentDateTimeRoundedToTheHour));
    //     $("#jobMatchScheduleStartTime").timepicker("setTime", _getTimeStringInAMPMFormat(currentDateTimeRoundedToTheHour));
    //     $('#jobMatchScheduleEndTime').timepicker("setTime", _getTimeStringInAMPMFormat(moment(currentDateTimeRoundedToTheHour).add(30, 'm').toDate()));
    // }
    ModifyPlanController.prototype.initializeStartAndEndDates = function () {
        var _this = this;
        $(document).ready(function () {
            var startDateTimeStringInSelectedTimeZone;
            var endDateTimeStringInSelectedTimeZone;
            var startDateTime;
            var endDateTime;
            var datePickerStartDate = new Date();
            if (_.isNull(_this.selectedPlan.planHeaderDto.timeZoneName) || _this.selectedPlan.planHeaderDto.timeZoneName == "") {
                _this.selectedPlan.planHeaderDto.timeZoneName = _this.browserTimeZone;
            }
            // if time zone information exists
            // get the time stamp string in the relevant time zone.
            startDateTimeStringInSelectedTimeZone = moment(_this.selectedPlan.planHeaderDto.unformattedStartDate).tz(_this.selectedPlan.planHeaderDto.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
            endDateTimeStringInSelectedTimeZone = moment(_this.selectedPlan.planHeaderDto.unformattedEndDate).tz(_this.selectedPlan.planHeaderDto.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
            startDateTime = new Date(startDateTimeStringInSelectedTimeZone);
            endDateTime = new Date(endDateTimeStringInSelectedTimeZone);
            if (!_this.isTrialPlan && _this.isModifyPlan) {
                datePickerStartDate = moment(startDateTimeStringInSelectedTimeZone).add(-1, 'd').toDate();
            }
            $('#effectiveStartDate').datepicker({
                format: "M d, yyyy",
                startDate: datePickerStartDate,
                weekStart: 1,
                autoclose: true
            });
            $("#effectiveStartDate").datepicker("setDate", startDateTime);
            $("#effectiveStartDate").datepicker("update", _this.$filter('fourdotfiveDateFormat')(startDateTime));
            $('#effectiveEndDate').datepicker({
                format: "M d, yyyy",
                weekStart: 1,
                startDate: startDateTime,
                autoclose: true
            });
            $("#effectiveEndDate").datepicker("setDate", endDateTime);
            $("#effectiveEndDate").datepicker("update", _this.$filter('fourdotfiveDateFormat')(endDateTime));
            $('#effectiveStartDate').datepicker().on('changeDate', function (e) {
                _this._validateStartAndEndDates();
            });
            $('#effectiveEndDate').datepicker().on('changeDate', function (e) {
                _this._validateStartAndEndDates();
            });
        });
    };
    ModifyPlanController.prototype._validateStartAndEndDates = function () {
        var currentStartDateTime = new Date(this.selectedPlan.planHeaderDto.planStartDateDisplay);
        var currentEndDateTime = new Date(this.selectedPlan.planHeaderDto.planEndDateDisplay);
        if (currentStartDateTime >= currentEndDateTime) {
            var resetEndDate = void 0;
            if (this.selectedPlan.planHeaderDto.planType == "Month to Month") {
                resetEndDate = moment(currentStartDateTime).add(1, 'M').endOf("day").toDate();
            }
            else {
                resetEndDate = moment(currentStartDateTime).add(6, 'M').endOf("day").toDate();
            }
            $("#effectiveEndDate").datepicker('setStartDate', moment(currentStartDateTime).endOf().toDate());
            $("#effectiveEndDate").datepicker("setDate", resetEndDate);
            $("#effectiveEndDate").datepicker("update", resetEndDate);
        }
        else {
            $("#effectiveEndDate").datepicker('setStartDate', moment(currentStartDateTime).endOf().toDate());
        }
    };
    ModifyPlanController.prototype.onPlanTypeChange = function () {
        console.log(this.selectedPlan.planHeaderDto.planType);
        var currentDate = new Date(moment(this.selectedPlan.planHeaderDto.unformattedStartDate).tz(this.selectedPlan.planHeaderDto.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS"));
        if (this.selectedPlan.planHeaderDto.planType == "Month to Month") {
            this.selectedPlan.planHeaderDto.planEndDateDisplay = this.$filter('fourdotfiveDateFormat')(moment(currentDate).add(1, 'M').toDate());
            this.selectedPlan.planHeaderDto.unformattedEndDate = moment(currentDate).add(1, 'M').toDate();
            this.selectedPlan.planHeaderDto.planEndDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.selectedPlan.planHeaderDto.unformattedEndDate));
        }
        else {
            this.selectedPlan.planHeaderDto.planEndDateDisplay = this.$filter('fourdotfiveDateFormat')(moment(currentDate).add(6, 'M').toDate());
            this.selectedPlan.planHeaderDto.unformattedEndDate = moment(currentDate).add(6, 'M').toDate();
            this.selectedPlan.planHeaderDto.planEndDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.selectedPlan.planHeaderDto.unformattedEndDate));
        }
        $("#effectiveEndDate").datepicker("setDate", this.selectedPlan.planHeaderDto.unformattedEndDate);
        $("#effectiveEndDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(this.selectedPlan.planHeaderDto.unformattedEndDate));
    };
    ModifyPlanController.prototype.cancel = function () {
        if (this.cancelCallback) {
            this.cancelCallback();
        }
    };
    ModifyPlanController.prototype.savePlan = function () {
        var message = "";
        this.selectedPlan.planHeaderDto.unformattedEndDate = moment(this.selectedPlan.planHeaderDto.planEndDateDisplay).toDate();
        this.selectedPlan.planHeaderDto.planEndDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(moment(new Date(this.selectedPlan.planHeaderDto.unformattedEndDate)).endOf("day").toDate());
        this.selectedPlan.planHeaderDto.unformattedStartDate = moment(this.selectedPlan.planHeaderDto.planStartDateDisplay).toDate();
        this.selectedPlan.planHeaderDto.planStartDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.selectedPlan.planHeaderDto.unformattedStartDate).setHours(0, 0, 0, 0));
        if (this.isTrialPlan) {
            this.selectedPlan.planDetailDto.taAllocated = this.selectedPlan.planDetailDto.taAllocated + this.selectedPlan.planDetailDto.taAdded;
            this.selectedPlan.planDetailDto.jbiAllocated = this.selectedPlan.planDetailDto.jbiAllocated + this.selectedPlan.planDetailDto.jbiAdded;
        }
        if (this.isModifyPlan && (this.isFuturePlanExists && new Date(this.selectedPlan.planHeaderDto.planEndDateDisplay) >= new Date(this.futurePlan.planHeaderDto.planStartDateDisplay))) {
            message = "Next plan's start date will be modified based on the current plan's end date. Do you want to continue?";
            this._showWarningMessage(message);
        }
        else if (!this.isModifyPlan && this.isActivePlanExists && this.currentPlanEndDate >= new Date(this.selectedPlan.planHeaderDto.planStartDateDisplay)) {
            message = "Current plan's end date will be modified based on this plan's start date. Do you want to continue?";
            this._showWarningMessage(message);
        }
        else {
            this._savePlan();
        }
    };
    ModifyPlanController.prototype._showWarningMessage = function (message) {
        var _this = this;
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
            message: message,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    _this._savePlan();
                }
            }
        });
    };
    ModifyPlanController.prototype._savePlan = function () {
        var _this = this;
        this.planService.savePlan(this.selectedPlan, function (data) {
            _this.selectedPlan = data;
            var successMessage = "";
            if (_this.isModifyPlan) {
                successMessage = "Company Plan modified successfully";
            }
            else {
                successMessage = "Company Plan chosen successfully";
            }
            _this.alertsAndNotificationsService.showBannerMessage(successMessage, 'success');
            if (_this.saveCallback) {
                _this.saveCallback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    return ModifyPlanController;
}());
ModifyPlanController.$inject = ['$rootScope', '$filter', 'planService', 'dateTimeUtilityService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './modify-plan.html';
import * as TEMPLATE from 'raw-loader!./modify-plan.html';
export var ModifyPlanComponent = {
    selector: 'modifyPlan',
    component: {
        bindings: {
            selectedPlan: '<',
            selectedPlanName: '<',
            futurePlan: '<',
            planTypeList: '<',
            isModifyPlan: '<',
            isActivePlanExists: '<',
            isFuturePlanExists: '<',
            currentPlanEndDate: '<',
            saveCallback: '&',
            cancelCallback: '&'
        },
        controller: ModifyPlanController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/company/modifyPlan/modify-plan.html'
    }
};
//# sourceMappingURL=modify-plan.component.js.map